import { Component, ChangeDetectionStrategy, OnDestroy, OnInit, HostListener, Inject } from '@angular/core';
import { TranslationService } from './modules/i18n/translation.service';

// language list (Not used but can't be removed)

import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as chLang } from './modules/i18n/vocabs/ch';
import { locale as esLang } from './modules/i18n/vocabs/es';
import { locale as jpLang } from './modules/i18n/vocabs/jp';
import { locale as deLang } from './modules/i18n/vocabs/de';
import { locale as frLang } from './modules/i18n/vocabs/fr';

import { SplashScreenService } from './_metronic/partials/layout/splash-screen/splash-screen.service';
import { Router, NavigationEnd, NavigationError, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { TableExtendedService } from './_metronic/shared/crud-table';
import { Title, Meta } from '@angular/platform-browser';
import { ActionService } from './services/action/action.service';
import { SeoService } from './services/seo/seo.service';
import { PlatformLocation, isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import {environment} from '../environments/environment';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {

    @HostListener('document:click', ['$event'])
    clickout(event) {
        this.actionService.setAction({
            action: 'clear-megamenus',
            data: null
        });
    }

    private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
    isBrowser: boolean = false;

    constructor(
        private translationService: TranslationService,
        private splashScreenService: SplashScreenService,
        public router: Router,
        private tableService: TableExtendedService,
        private route: ActivatedRoute,
        private actionService: ActionService,
        private titleService: Title,
        private metaTagService: Meta,
        private platformLocation: PlatformLocation,
        @Inject(PLATFORM_ID) platformId: Object,
        private seoService: SeoService
    ) {

        this.translationService.loadTranslations(
            enLang,
            chLang,
            esLang,
            jpLang,
            deLang,
            frLang
        );
        this.isBrowser = isPlatformBrowser(platformId);
    }

    ngOnInit() {

        this.seoService.createLinkForCanonicalURL();
        const routerSubscription = this.router.events.subscribe((event) => {

            // SEO DEFAULTS (THESE GET OVERWRITTEN BY PAGE BUILDER)
            const title = 'IBTC';
            const description = 'IBTC offers Professional Business Education in courses like CIMA, ICB and ACCA. With options to study from home, in classes or online. Pass Assured.';
            const keywords = 'Distance learning courses, home study courses, IBTC';
            this.titleService.setTitle(title);

            this.seoService.updateLinkForCanonicalURL();

            if (environment.NOINDEX) {
                this.metaTagService.updateTag(
                    { name: 'robots', content: 'noindex' }
                );
            }
            this.metaTagService.updateTag(
                { name: 'description', content: description }
            );
            this.metaTagService.updateTag(
                { name: 'keywords', content: keywords }
            );
            this.metaTagService.updateTag({ property: 'og:title', content: title });
            this.metaTagService.updateTag({ property: 'og:description', content: description });

            this.metaTagService.updateTag({ property: 'og:url', content: 'https://ibtc.co.za' + this.platformLocation.pathname });
            this.metaTagService.updateTag({ property: 'og:image', content: 'https://ibtc.co.za' + '/assets/img/ibtc-logo.webp' });

            if (event instanceof NavigationEnd && this.isBrowser) {

                // Save UTM Variables for use in the forms
                this.route.queryParams.subscribe((queryParams: any) => {
                    if (queryParams.utm_source) {
                        sessionStorage.setItem('utmSource', queryParams.utm_source);
                    }
                    // No UTM source
                    else {
                        const referredBy = document.referrer.split('/')[2];

                        // Set a default UTM source
                        sessionStorage.setItem('utmSource', referredBy);

                        // No UTM medium
                        if (!queryParams.utm_medium) {

                            // No UTM source or medium set and has gclid param.
                            if (queryParams.gclid) {
                                sessionStorage.setItem('utmSource', 'google');
                                sessionStorage.setItem('utmMedium', 'cpc');

                            // Blank document.referrer, direct traffic
                            } else if (document.referrer === '') {
                                sessionStorage.setItem('utmSource', 'direct');
                            // google
                            } else if (referredBy.indexOf('google.') >= 0 || referredBy.indexOf('www.google') >= 0) {
                                sessionStorage.setItem('utmSource', 'google');
                                sessionStorage.setItem('utmMedium', 'organic');
                            // facebook
                            } else if (referredBy.indexOf('facebook.') >= 0 || referredBy.indexOf('www.facebook') >= 0) {
                                sessionStorage.setItem('utmSource', 'facebook');
                                sessionStorage.setItem('utmMedium', 'organic');
                            // twitter
                            } else if (referredBy.indexOf('twitter.') >= 0 || referredBy.indexOf('www.twitter') >= 0) {
                                sessionStorage.setItem('utmSource', 'twitter');
                                sessionStorage.setItem('utmMedium', 'organic');
                            // instagram
                            } else if (referredBy.indexOf('instagram.') >= 0 || referredBy.indexOf('www.instagram') >= 0) {
                                sessionStorage.setItem('utmSource', 'instagram');
                                sessionStorage.setItem('utmMedium', 'organic');
                            }
                        }
                    }

                    if (queryParams.utm_medium) {
                        sessionStorage.setItem('utmMedium', queryParams.utm_medium);
                    }

                    if (queryParams.utm_campaign) {
                        sessionStorage.setItem('utmCampaign', queryParams.utm_campaign);
                    }

                    if (queryParams.utm_content) {
                        sessionStorage.setItem('utmContent', queryParams.utm_content);
                    }

                    if (queryParams.utm_term) {
                        sessionStorage.setItem('utmTerm', queryParams.utm_term);
                    }
                });

                // clear filtration paginations and others
                this.tableService.setDefaults();
                // hide splash screen
                this.splashScreenService.hide();

                // scroll to top on every route change
                // window.scrollTo(0, 0);

                // to display back the body content
                setTimeout(() => {
                    document.body.classList.add('page-loaded');
                }, 500);
            }
        });

        this.unsubscribe.push(routerSubscription);

    }

    ngOnDestroy() {

        this.unsubscribe.forEach((sb) => sb.unsubscribe());

    }
}
